import { useRef, useState } from "react";
import { motion } from "framer-motion";
import { Play } from "lucide-react";

export default function OurWork() {
  const videoRef = useRef(null);
  const [playing, setPlaying] = useState(false);

  const handlePlay = () => {
    const v = videoRef.current;
    if (!v) return;
    v.muted = false;
    v.play();
    setPlaying(true);
  };

  return (
    <section id="unsere-arbeit" className="relative py-20 md:py-28 bg-ink overflow-hidden" data-testid="our-work-section">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-4 mb-5">
            <span className="h-px w-12 bg-volt/50" />
            <span className="text-xs md:text-sm font-bold tracking-[0.25em] uppercase text-volt">Unsere Arbeit</span>
            <span className="h-px w-12 bg-volt/50" />
          </div>
          <motion.h2 initial={{ opacity: 0, y: 30 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.6 }}
            className="font-heading font-black uppercase tracking-tighter text-4xl md:text-6xl text-white leading-[0.95]">
            VoltCore <span className="text-volt">in Aktion</span>
          </motion.h2>
          <motion.p initial={{ opacity: 0 }} whileInView={{ opacity: 1 }} viewport={{ once: true }} transition={{ duration: 0.6, delay: 0.15 }}
            className="mt-5 max-w-xl mx-auto text-white/60 font-medium">
            Sehen Sie unser Team bei der Arbeit – präzise Kernbohrungen und saubere Elektrovorbereitung, direkt von der Baustelle.
          </motion.p>
        </div>

        <motion.div initial={{ opacity: 0, y: 50 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
          className="relative mx-auto max-w-[420px] rounded-3xl overflow-hidden border border-volt/25 bg-black shadow-[0_40px_100px_rgba(0,0,0,0.7)]">
          <video ref={videoRef} data-testid="our-work-video" controls={playing} loop playsInline preload="none"
            poster="/hero-poster.jpg" className="w-full h-auto block aspect-[9/16] object-cover">
            <source src="/hero-video.webm" type="video/webm" />
            <source src="/hero-video.mp4" type="video/mp4" />
          </video>

          {!playing && (
            <button onClick={handlePlay} data-testid="our-work-play"
              className="group absolute inset-0 grid place-items-center bg-black/30 hover:bg-black/20 transition-colors duration-300"
              aria-label="Video abspielen">
              <span className="relative grid place-items-center h-20 w-20 rounded-full bg-volt text-black shadow-[0_0_40px_rgba(245,133,26,0.55)] transition-transform duration-300 group-hover:scale-110">
                <span className="absolute inset-0 rounded-full bg-volt/40 animate-ping" />
                <Play className="h-8 w-8 ml-1 fill-black" />
              </span>
            </button>
          )}
        </motion.div>
      </div>
    </section>
  );
}
